module.exports = __webpack_public_path__ + "img/materials_en.b7a442d.jpg";